export const UPDATE_LEAD_PREFERENCES_REQUEST =
  'UPDATE_LEAD_PREFERENCES_REQUEST';
export const UPDATE_LEAD_PREFERENCES_SUCCESS =
  'UPDATE_LEAD_PREFERENCES_SUCCESS';
export const UPDATE_LEAD_PREFERENCES_FAILURE =
  'UPDATE_LEAD_PREFERENCES_FAILURE';
